export const DIALOG_DEFAULT_MESSAGE: Record<'error', { message: string; title: string }> = {
  error: {
    message: 'If this persist please contact support',
    title: 'Oops! Something went wrong',
  },
};

export const NOTIFY_DEFAULT_MESSAGE: Record<'error' | 'success', string> = {
  error: 'Error: request could not be completed',
  success: 'Request was succesfully completed',
};
